import React from 'react'

const Loader = ({ className }) => {
  return <i className={`fas fa-spinner-third fa-spin ${className || ''}`} />
}

export default Loader
